(function waitAndOverride() {
    const interval = setInterval(() => {
        if (window.probance_ros) {

            const currentUrl = window.location.origin + window.location.pathname;

            window.probance_ros.getMiniatures = async function (handles) {
                const list = Array.isArray(handles) ? handles : [handles];
                const url = `${currentUrl}?section_id=probance-ros-banner&handles=${list.join(',')}`;

                const res = await fetch(url);
                const html = await res.text();

                const wrapper = document.createElement('div');
                wrapper.innerHTML = html;

                const items = wrapper.querySelectorAll('.product-item'); 

                const result = list.map((handle, i) => ({
                    productId: null,
                    cmsCardId: handle,
                    html: items[i]?.outerHTML || null
                }));

                return result;
            };

            clearInterval(interval);
        }
    }, 50);
})();